import { ImpactModule } from 'types'
import { DATA_INTEGRATOR_PAGES } from './pages'
import { DATA_INTEGRATOR_PAGES_ORDER_FOR_PERMISSIONS } from './pagesOrderForPermissions'

export const DATA_INTEGRATOR_MODULE: ImpactModule = {
  NAME: 'data-integrator',
  NAME_PTBR: 'Integrador de dados',
  UPPER_NAME: 'INTEGRATOR',
  API_NAME: 'INTEGRATOR',
  PAGES: DATA_INTEGRATOR_PAGES,
  PAGES_ORDER_FOR_PERMISSIONS: DATA_INTEGRATOR_PAGES_ORDER_FOR_PERMISSIONS,
}
